import {Box, styled, Tooltip} from '@mui/material';
import React, {HTMLAttributes, useState} from "react";
import useMeasure from "react-use-measure";

function getSize(variant: string): string {
    switch (variant) {
        case 'my-orders':
            return '1.13rem';
        case 'header':
            return '0.88rem';
        case '1rem':
            return '1rem';
        case 'xxs':
            return '0.5rem';
        case 'xs':
            return '0.63rem';
        case 's':
            return '0.75rem';
        case 'm':
            return '0.88rem';
        case 'l':
            return '1.13rem';
        case 'xl':
            return '1.25rem';
        case 'xxl':
            return '1.5rem';
        case 'xxxl':
            return '2.25rem';
        case 'extra-xxxl':
            return '3.25rem';
        default:
            return 'unset';
    }
}

const StyledText = styled(({textAlign, ...props}: any) => (
    <span {...props}
          style={{
              fontSize: getSize(props.variant),
              opacity: props.opacity || 'unset',
              textAlign: textAlign || 'unset',
              verticalAlign: 'middle',
              fontWeight: props.weight,
              textOverflow: 'ellipsis',
              width: props.width || '100%',
              display: 'inline-block',
              overflow: props.overflow || 'hidden',
              color: props.color,
              ...(props.style || {})
          }}
          >
        {props.children}

        {props.required ? <span style={{color: '#D42D4A'}}> *</span> : ''}
    </span>
))({
    textTransform: 'none',
});

const BarekamText = ({fontWeight, bold, opaque, align, maxWidth, ...props}: BarekamTextProps) => {
    const [ref, bounds] = maxWidth ? useMeasure() : [];
    const [isWithTooltip, setIsWithTooltip] = useState(false);

    if (maxWidth && !isWithTooltip && bounds && bounds.width / 16 > maxWidth) {
        setIsWithTooltip(true);
    }

    const weight = bold ? 'bold' : fontWeight;
    const opacity = opaque ? '0.6' : '1';
    const textAlign = align || 'left';

    return (
        <Box ref={ref} width={props.width} height={props.style ? props.style.height : 'unset'} overflow={props.overflow || 'unset'}>
            {isWithTooltip
                ? <Tooltip title={props.children} placement={'right'}>
                    <div style={{width: maxWidth + 'rem'}}>
                        <StyledText weight={weight} opacity={opacity} textAlign={textAlign} {...props}/>
                    </div>
                </Tooltip>
                : <StyledText weight={weight} opacity={opacity} textAlign={textAlign} {...props}/>
            }
        </Box>
    )
};

export default BarekamText;

interface BarekamTextProps extends HTMLAttributes<any> {
    variant: "my-orders" | "header" | "1rem" | "xxs" | "xs" | "s" | "m" | "l" | "xl" | "xxl" | "xxxl" | "extra-xxxl",
    children: any,
    bold?: boolean,
    fontWeight?: number,
    width?: number | string,
    opaque?: boolean,
    align?: 'left' | 'right' | 'center',
    overflow?: 'visible' | 'hidden' | 'clip' | 'scroll' | 'auto' | 'initial' | 'inherit' | 'unset',
    required?: boolean,
    maxWidth?: number,
}
